import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { TOPBAR_HEIGHT } from '@root/shared/ui-kit/utils/page-layout'
import { TopbarEnd } from '@root/widgets/layout/desktop-layout'

import { topbarModeAtom } from './atoms'
import { TopBarSwitch } from './common'
import { TOPBAR_BG_COLOR } from './constants'
import * as TopbarMode from './model/topbar-mode'
import { TopbarFavorites } from './topbar-favorites'
import { TopbarPositions } from './topbar-positions'
import { TopbarRecentSearch } from './topbar-recent-search'
import { TopbarTrending } from './topbar-trending'

import type { ClassNameProps } from '@root/shared/react'

type HeaderProps = {} & ClassNameProps

const MARQUEE_VARIANT = 'interactive'

export const Topbar: React.FC<HeaderProps> = ({ className }) => {
  const [mode] = useAtom(topbarModeAtom)

  const cmp = TopbarMode.match(mode, {
    favorites: () => <TopbarFavorites />,
    positions: () => <TopbarPositions />,
    trending: () => <TopbarTrending variant={MARQUEE_VARIANT} />,
    recentSearch: () => <TopbarRecentSearch />,
  })

  return (
    <Root className={className}>
      <TopBarSwitch />
      {cmp}
      <TopbarEnd />
    </Root>
  )
}

const Root = styled.div`
  height: ${TOPBAR_HEIGHT}px;
  background: ${TOPBAR_BG_COLOR};
  border-bottom: 1px solid var(--background-3);
  padding-inline: 8px 0;

  display: grid;
  gap: 4px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
`
